import { createContext } from 'react';

const MercadoPagoTDCContext = createContext();

export default MercadoPagoTDCContext;
